import '@firebase/auth';
//# sourceMappingURL=index.esm.js.map
